import { createSelector } from 'reselect';
import { selector } from './reducer';

export const visibleSelector = createSelector(selector, (state) => state.visible);
export const messageSelector = createSelector(selector, (state) => state.message);
export const statusSelector = createSelector(selector, (state) => state.status);



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/statusDialog/selectors.tsx